export const generalEmailAddress = 'contact@championnatdumondeduchoufarci.com';

export const artcutiersUrl = 'https://www.lesartcutiers.com';
export const bernardaudUrl = 'https://www.bernardaud.com';
export const instagram = 'https://www.instagram.com/championnatdumondeduchoufarci/';
export const linkedin = 'https://www.linkedin.com/company/bernardaud/';
